import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const AllSuggestedTalents = () => {
  const { id } = useParams();
  const [talents, setTalents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/matching/suggestions/${id}`);
      setTalents(res.data || []);
    };
    fetchData();
  }, [id]);

  return (
    <div style={{ padding: '32px' }}>
      <h2>Tous les talents suggérés</h2>
      <ul>
        {talents.map((t, i) => (
          <li key={i}>
            {t.prenomCandidat} {t.nomCandidat} – Score : {(t.similarity * 100).toFixed(1)}%
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AllSuggestedTalents;
